/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsTeamBanRateDtoSchema = z.object({
  championName: z.string().nullish(),
  banCount: z.optional(z.int()),
  totalGames: z.optional(z.int()),
  banRate: z.optional(z.number()),
});
